/* eslint-disable-next-line */
import http from './index';

/**
 * 教师班级讲次列表[教师]
 * @param {integer} classType 授课类型【1-本分校海边，2.双师，4-面授，8-直播】
 * @param {string} subjectId 科目ID
 * @param {string} teacherType 教师类型【0-主讲，1-辅导，2-班主任】
 */
export function getCourseList(params) {
  return http({
    url: '/core/teachers/classes',
    method: 'GET',
    params,
  });
}

/**
 * 查询题目列表[教师]
 * @param {string} classId 班级ID
 * @param {string} curriculumNo 课次序号
 */
export function getPracticeList(params) {
  return http({
    url: '/core/lesson/t-practices',
    method: 'GET',
    params,
  });
}

/**
 * 单个题组练习题列表[教师]
 * @param {string} bundleId 题组ID
 * @param {string} classId 班级ID
 */
export function getSubject(params) {
  return http({
    url: '/core/compiler/t-practices',
    method: 'GET',
    params,
  });
}

/**
 * 查询课后题目列表[教师]
 * @param {string} cityCode 分校编码
 * @param {string} classId 班级ID
 * @param {string} curriculumNo 课次序号
 * @param {string} studentId 课次序号
 */
export function getAfterPracticeList(params) {
  return http({
    url: '/core/lesson/s-practices/afterclass',
    method: 'GET',
    params,
  });
}

/**
 * 发放题组
 * @param {string} cityCode 分校编码
 * @param {string} classId 培优班级ID
 * @param {integer} cucNum 培优课次序号
 * @param {string} bundleId 题组ID
 * @param {string} lessonId 讲次ID
 */
export function sendPracticeGroup(params) {
  return http({
    url: '/core/bundles/batch-publish',
    method: 'POST',
    data: params,
  });
}

/**
 * 收题组
 * @param {string} cityCode 分校编码
 * @param {string} classId 培优班级ID
 * @param {integer} cucNum 培优课次序号
 * @param {string} bundleId 题组ID
 * @param {string} lessonId 讲次ID
 */
export function receivePracticeGroup(params) {
  return http({
    url: '/core/bundles/batch-unpublish',
    method: 'POST',
    data: params,
  });
}

/**
 * 生成登录教师的超级密码
 * No parameters
 */
export function getSuperPower() {
  return http({
    url: '/core/teachers/generateSuperPwd',
    method: 'POST',
  });
}

/**
 * 获取学员点评列表
 * @param {string} classId 培优班级ID
 * @param {integer} cucNum 培优课次序号
 */
export function getReviewStudents(params) {
  return http({
    url: `/core/review/students/${params.classId}/${params.cucNum}`,
    method: 'GET',
  });
}

/**
 * 下载学员点评列表
 * @param {string} classId 培优班级ID
 * @param {integer} cucNum 培优课次序号
 */
export function downloadCommit(params) {
  return http({
    url: `/core/review/students/download/${params.classId}/${params.cucNum}`,
    method: 'GET',
    responseType: 'blob',
  });
}

/**
 * 下载学员竞赛评分列表
 * @param {string} classId 培优班级ID
 * @param {integer} cucNum 培优课次序号
 */
export function downloadCompetition(params) {
  return http({
    url: `/core/review/students/competition/download/${params.classId}/${params.cucNum}`,
    method: 'GET',
    responseType: 'blob',
  });
}
/**
 * 下载学员竞赛评分列表
 * @param {string} classId 培优班级ID
 * @param {integer} cucNum 培优课次序号
 */

export function downloadCompetitionComment(params) {
  return http({
    url: `/core/review/students/download/${params.classId}/${params.cucNum}`,
    method: 'GET',
    responseType: 'blob',
  });
}

/**
 * 开放提交
 * @param {string} bundleId 题组ID
 * @param {string} classId 培优班级ID
 * @param {integer} isSetOpen 是否设置为开放
 * @param {string} lessonId 讲次ID
 */
export function changeGroupStatus(params) {
  return http({
    url: '/core/practices/status',
    method: 'POST',
    data: params,
  });
}

/**
 * 开放提交
 * @param {string} category 习题类型
 * @param {string} cityCode 培优分校编码
 * @param {string} bundleId 题组ID
 * @param {string} classId 培优班级ID
 * @param {integer} cucNum 培优课次序号
 * @param {string} lessonId 讲次ID
 * @param {string} projectId 习题的项目ID
 */
export function checkStudentWord(params) {
  return http({
    url: '/core/students/practices/check',
    method: 'GET',
    params,
  });
}

/**
 * 记录CM的答题结果
 * @param {string} code 代码
 * @param {string} classId 培优班级ID
 * @param {string} lessonId 讲次ID
 * @param {integer} projectId 习题对应的项目ID
 * @param {integer} stars 星星数
 * @param {integer} time 习题对应的项目ID
 */
export function sendStarNum(params) {
  return http({
    url: '/core/cm/solution',
    method: 'POST',
    data: params,
  });
}

/**
 * 保存Solution的URL
 * @param {string} classId 培优班级ID
 * @param {string} lessonId 讲次ID
 * @param {integer} projectId 习题对应的项目ID
 * @param {string} url URL
 */
export function saveCMUrl(params) {
  return http({
    url: '/cm/solution',
    method: 'PUT',
    data: params,
  });
}

/**
 * 获取CM的答题结果
 * @param {string} cityCode 城市编码
 * @param {string} classId 培优班级ID
 * @param {string} lessonId 讲次ID
 * @param {integer} projectId 习题对应的项目ID
 * @param {integer} studentId 学生ID
 */
export function getCMResult(params) {
  return http({
    url: '/cm/solution',
    method: 'GET',
    params,
  });
}

export function newGetCMResult(id) {
  return http({
    url: `/core/cm/solution/${id}`,
    method: 'GET',
  });
}


/**
 * 获取CM的答题结果
 * @param {string} id CM项目ID(Solution ID)
 */
export function getCMResultUrl(id) {
  return http({
    url: `/core/cm/solution/${id}/url`,
    method: 'GET',
  });
}

// /**
//  * 保存点评
//  * @param {string} cityCode 城市编码
//  * @param {string} bundleId 题组ID
//  * @param {string} comment 评语
//  * @param {integer} studentId 学生ID
//  */
// export function saveReview(params) {
//   return http({
//     url: '/core/review',
//     method: 'POST',
//     data: params,
//   });
// }

/**
 * 提交/驳回点评
 * @param {string} cityCode 城市编码
 * @param {string} bundleId 题组ID
 * @param {string} comment 评语
 * @param {integer} studentId 学生ID
 * @param {string} op 提交或驳回（1-提交，3-驳回 2-通过）
 */
export function crReview(params) {
  return http({
    url: '/core/review',
    method: 'PUT',
    data: params,
  });
}

/**
 * 保存/提交/驳回点评
 * @param {string} cityCode 城市编码
 * @param {string} bundleId 题组ID
 * @param {string} comment 评语
 * @param {string} studentId 学生ID
 * @param {string} studentName 学生姓名
 * @param {integer} status  提交或驳回（1-保存 2-通过 3-驳回）
 */
export function putReview(params) {
  return http({
    url: '/core/review',
    method: 'PUT',
    data: params,
  });
}

/**
 * 教师端-给某学生的一组题评分
 * @param {string} classId 班级ID
 * @param {string} lessonId 讲次ID
 * @param {string} studentId 学生ID
 * @param {array} scoreItems 分数列表
 * @scoreItems {integer} category 习题类型
 * @scoreItems {integer} projectId 习题对应的CM项目ID
 * @scoreItems {integer} score 分数列表
 */
export function putScore(params) {
  return http({
    url: '/core/review/grade',
    method: 'POST',
    data: params,
  });
}

/**
 * 获得选择题内容
 * @param {integer} id 选择题题目ID
 */
export function getQuestion(params) {
  return http({
    url: '/choice/question',
    method: 'GET',
    params,
  });
}

/**
 * 教师获得选择题作业
 * @param {string} cityCode 城市编码
 * @param {integer} questionId 题目ID
 * @param {string} studentId 学员ID
 */
export function getTeacherAnswer(params) {
  return http({
    url: '/choice/answer/teacherGet',
    method: 'GET',
    params,
  });
}

/**
 * 获取讲次答题统计
 * @param {string} classId 班级ID
 */
export function getReportAnswer(params) {
  return http({
    url: '/core/stats/lesson/answer',
    method: 'GET',
    params,
  });
}

/**
 * 获取学生习题统计
 * @param {string} classId 班级ID
 * @param {string} cucNum 课次序号
 */
export function getPracticeAnswer(params) {
  return http({
    url: '/core/stats/stu/practice',
    method: 'GET',
    params,
  });
}

/**
 * 教师获取自己Paper答案
 * @param {string} classId 班级ID
 * @param {string} lessonId 讲次ID
 * @param {string} questionId paper习题ID
 * @param {string} studentId 学生ID
 */
export function teaGetPaperAnswer(params) {
  return http({
    url: '/paper/answer/teacherGet',
    method: 'GET',
    params,
  });
}

/**
 * 教师端发送IM消息
 * @param {string} cityCode 分校编码
 * @param {string} courseId 培优课程ID
 * @param {integer} cucNum 培优课次序号
 * @param {string} bundleId 题组ID
 * @param {string} lessonId 讲次ID
 * @param {string} practiceId 习题Id
 * @param {Object} tips 教师发送的信息内容
 *【 desc: 文字描述； tipType: 1文字加代码、2文字加图片; code: 代码字符串；imageUrl: 图片url; imageKey: 图片key 】
 */
export function imSend(params) {
  return http({
    url: '/core/tips/batchSend',
    method: 'POST',
    data: params,
  });
}

/**
 * 获取猴博士题目描述和默认提示的接口
 * @param {string} practiceId 习题Id
 * @param {Number} category 习题类型
 */
export function getHbs(params) {
  return http({
    url: '/core/doctor/tip',
    method: 'GET',
    params,
  });
}

/**
 * 获取scratch判题结果
 * @param {string} exerciseId
 */
export function getScratchOj(params) {
  return http({
    url: `/core/doctor/scratch/${params.exerciseId}`,
    method: 'GET',
  });
}

/**
 * 查看教师提示此题最后一次发送的信息
 * @param {string} bundleId 题组ID
 * @param {string} courseId 培优课程ID
 * @param {string} lessonId 讲次ID
 * @param {string} practiceId 习题Id
 * @param {string} token token
 */
export function lastMsg(params) {
  return http({
    url: '/core/tips/last',
    method: 'GET',
    params,
  });
}

/**
 * 获取点评模版列表接口
 * @param {string} lessonId 讲次Id
 */
export function getBlcoksList(params) {
  return http({
    url: '/core/review/template',
    method: 'GET',
    params,
  });
}

/**
 * 创建自定义点评模版接口
 * @param {string} lessonId 讲次Id
 */
export function addBlcok(params) {
  return http({
    url: '/core/review/template',
    method: 'POST',
    data: params,
  });
}
